
import React from 'react';
import './LinkedInIcon.css';

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.447 0-2.339-.915-2.339-2.186 0-1.247.892-2.183 2.339-2.183s2.34.936 2.34 2.183c0 1.271-.893 2.186-2.34 2.186zm1.787 13.019H3.55v-11.66h3.574v11.66zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.454c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.208 0 22.225 0z"/>
  </svg>
);

export default LinkedInIcon;
